module.exports = __webpack_public_path__ + "img/pro-app-thumb.8c828e2c.jpg";